let cachedIpAddress: string | null = null;

export async function getClientIpAddress(): Promise<string> {
  if (cachedIpAddress) {
    return cachedIpAddress;
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);

    const response = await fetch('https://api.ipify.org?format=json', {
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error('Failed to fetch IP address');
    }

    const data = await response.json();
    cachedIpAddress = data.ip || 'unavailable';
    return cachedIpAddress;
  } catch (error) {
    console.error('Error fetching IP address:', error);
    cachedIpAddress = 'unavailable';
    return 'unavailable';
  }
}
